// extracted by mini-css-extract-plugin
export default {"btn":"CommentControl_btn__3H1Eo","edit":"CommentControl_edit__CMHRd","delete":"CommentControl_delete__j59j3","reply":"CommentControl_reply__AXJCY"};